import { faFileSignature } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FileUploader } from "react-drag-drop-files";
import Moment from "react-moment";
import {
  FORMAT_DATE_MOMENT,
  STATUS_CREATED,
  STATUS_INACTIVE,
} from "../../../../../api/constant";
import "./dataSheet.css";
import Toggle from "react-toggle";
import {
  useActionsArticle,
  useArticle,
  useDispatchArticleForm,
} from "../../../../../context/inventory/ArticleFormProvider";
import { types } from "../../../../../reducers/inventory/articleReducer";
import IconFile from "../../../../app/atoms/IconFile";
import FileUpload from "../../../../app/atoms/FileUpload";
import { pdfjs } from 'react-pdf';
import { PdfModal } from "../../../../app/atoms/PdfModal";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();


const DataSheet = () => {
  const state = useArticle();
  const dispatchArticleForm = useDispatchArticleForm();
  const actions = useActionsArticle();
  const { open_data_sheet_modal } = state.article;
  const { elements: documents } = state.article.documents;

  const handleChange = (files) => {
    actions.uploadFilesDataSheet(files);
  };
  const fileTypes = ["PDF"];


  const [openModal, setOpenModal] = useState(false);
  const selectedPdf = state.article.selectedPdf ?? null;

  const openPdf = (doc) => {
    actions.loadDocumentForView(doc);
    setOpenModal(true);
  };


  return (
    <div style={{flexWrap:"wrap"}} className="flex">
      <div style={{width:"auto",marginBottom:"3px"}} className=" container-fluid flex-column">
        <div className="flex justify-betwen">
          <label className="font1">Suba archivos {JSON.stringify(fileTypes)}</label>
        </div>
        <div className="container-drop-file-entry">
          <FileUpload handleChange={handleChange} fileTypes={fileTypes} />
        </div>
      </div>
      <div className="flex1 flex">
        <div className="flex1">
          {" "}
          <label  style={{padding:"0.5rem"}} className="font1">Habilitadas</label>
          <div>
            {" "}
            <table className="table no-bordered table-documents-entry">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Modificado por</th>
                  <th className="d-none d-xl-block">Última modificación</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {documents
                  .filter((d) => d.status_id === STATUS_CREATED)
                  .map((doc) => {
                    return (
                      <tr key={doc.id}>
                        <td
                          title={doc.title}
                          style={{ maxWidth: "120px" }}
                          className="txt-short"
                          onClick={() => openPdf(doc)}
                        >
                          <IconFile type={doc.type} /> {doc.title}{" "}
                        </td>
                        <td>{doc.user_name}</td>
                        <td className="d-none d-xl-block">
                          <Moment format={FORMAT_DATE_MOMENT}>
                            {doc.updated_at}
                          </Moment>
                        </td>
                        <td>
                          {" "}
                          <Toggle
                            checked={true}
                            icons={false}
                            onChange={(e) =>
                              actions.changeStatusDocument(
                                doc.id,
                                STATUS_INACTIVE
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
        <div style={{borderLeft:"black solid 0.7px"}} className="flex1">
          {" "}
          <label style={{padding:"0.5rem"}} className="font1">Deshabilitadas</label>{" "}
          <div>
            <table className="table no-bordered table-documents-entry">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Modificado por</th>
                  <th className="d-none d-xl-block">Última modificación</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {documents
                  .filter((d) => d.status_id === STATUS_INACTIVE)
                  .map((doc) => {
                    return (
                      <tr key={doc.id}>
                        <td
                          title={doc.title}
                          style={{ maxWidth: "120px" }}
                          className="txt-short"
                        >
                          <IconFile type={doc.type} /> {doc.title}{" "}
                        </td>
                        <td>{doc.user_name}</td>
                        <td className="d-none d-xl-block">
                          <Moment format={FORMAT_DATE_MOMENT}>
                            {doc.updated_at}
                          </Moment>
                        </td>
                        <td>
                          <Toggle
                            icons={false}
                            checked={false}
                            onChange={(e) =>
                              actions.changeStatusDocument(
                                doc.id,
                                STATUS_CREATED
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <PdfModal 
        open={openModal} 
        pdfFile={selectedPdf}
        onClose={() => {
          setOpenModal(false);
          dispatchArticleForm({ type: types.SET_SELECTED_PDF, payload: null });
        }}
      />
    </div>
  );
};

export default DataSheet;
